import React from 'react'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { EndGameMode } from '@/constants/room'

interface EndGameModalProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  isLoading?: boolean
  mode?: EndGameMode
}

export const EndGameModal: React.FC<EndGameModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
  mode = EndGameMode.Game,
}) => {
  const isSimulation = mode === EndGameMode.Simulation
  const title = isSimulation ? 'End Pilot' : 'End Game'
  const description = isSimulation
    ? 'Are you sure you want to end the pilot? All pilot data (conversations, decisions, negotiations, and dummy players) will be deleted and the game will be reset to its initial state.'
    : 'Are you sure you want to end the game? All players will lose access to this room.'
  const buttonText = isSimulation ? 'End Pilot' : 'End Game'
  const loadingText = isSimulation ? 'Ending Pilot...' : 'Ending Game...'

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className='sm:max-w-[27.4rem] pt-8 pb-6'>
        <DialogHeader>
          <DialogTitle className='text-base font-bold text-[#0F172A]'>
            {title}
          </DialogTitle>
          <DialogDescription className='mt-4 text-base text-[#64748B]'>
            {description}
          </DialogDescription>
        </DialogHeader>
        <div className='flex justify-end space-x-3 mt-6'>
          <Button
            variant='secondary'
            onClick={onClose}
            disabled={isLoading}
            className='bg-gray-100 hover:bg-gray-200 text-gray-900'
          >
            Cancel
          </Button>
          <Button
            onClick={onConfirm}
            disabled={isLoading}
            className='bg-red-600 hover:bg-red-700 text-white'
          >
            {isLoading ? loadingText : buttonText}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
